import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getPageType } from "../utils/PageTypeSelector";

export async function retrieveContent<P>(name: string): Promise<P> {
  let contentLocation;
  if (name === "ComponentTestPage") {
    contentLocation = `/kentico/assets/content/${name}.json?v=${process.env.REACT_APP_VERSION}`;
  } else {
    contentLocation = `/kentico_content/${name}.json?v=${process.env.REACT_APP_VERSION}`;
  }
  return fetch(contentLocation, {
    headers: new Headers({
      "Content-Type": "application/json; charset=utf-8",
    }),
  }).then(response => response.json());
}

interface Result<P> {
  content: P;
}

export function useContent<P>(name: string, initialValue: P ): Result<P> {
  const [content, setContent] = useState<P>(initialValue);

  useEffect(() => {
    const fetchData = async () => {
      const result = await retrieveContent<P>(name);
      setContent(result);
    };

    fetchData();
  }, [name]);

  return { content };
}

export function usePageTypeContent<P>(name: string, initialValue: P ): Result<P> {
  const contentName = `${getPageType(useLocation().pathname)}/${name}`;
  return useContent(contentName, initialValue);
}
